import './FaqBox.scss';

const FaqBox = (() => {
    const collapseBtns = [...document.getElementsByClassName('js-coll')];

    const toggleMenu = ({ currentTarget }) => {
      [...currentTarget.children].map(label => label.classList.toggle('inactive'));
      const menuElems = [...currentTarget.previousElementSibling.children].filter((elem, index) => index > 3);
      menuElems.map(menuElem => menuElem.classList.toggle('inactive'));
    };

    collapseBtns.map(collapseBtn => collapseBtn.addEventListener('click', toggleMenu));

})();

export default FaqBox;
